import { Injectable } from '@angular/core';
import {ServerService} from "./ServerService";

@Injectable({
  providedIn: 'root'
})
export class ImportadorIfoodService    extends ServerService {

  listeNovosProdutosIfood(link: string, reducao: number, sincronizarPrecos: boolean = false,
                          sincronizarImagens: boolean = false, salvarDadosEmpresa: boolean = false){
    let params: any = {};

    if(reducao >= 0) params.reducao = reducao;
    if(sincronizarPrecos) params.precos = true;
    if(sincronizarImagens) params.imagens = true;
    if(salvarDadosEmpresa) params.salvarDadosEmpresa = true;

    const idLoja = this.obtenhaIdDaLoja(link)

    return this.obtenha(  String(`/importador/ifood/produtos/${idLoja}/novos`), params)
  }

  listeNovosProdutosIfoodOficial(idLoja: string, reducao: number, sincronizarPrecos: boolean = false,
                          sincronizarImagens: boolean = false, idCatalogo: string = null,
                          salvarDadosEmpresa: boolean = false){
    let params: any = {};

    if(reducao >= 0) params.reducao = reducao;
    if(sincronizarPrecos) params.precos = true;
    if(sincronizarImagens) params.imagens = true;
    if(idCatalogo) params.catalogoId = idCatalogo;
    if(salvarDadosEmpresa) params.salvarDadosEmpresa = true;


    return this.obtenha(  String(`/importador/ifoodoficial/produtos/${idLoja}/novos`), params)
  }

  listeAdicionaisIfoodOficial(idLoja: string, idsProdutosIfood: string[], reducao: number, idCatalogo: string = null){
    return this.obtenha(String(`/importador/ifoodoficial/produtos/${idLoja}/adicionais`), {
      idsProdutosIfood: idsProdutosIfood,
      reducao: reducao,
      catalogoId: idCatalogo
    })
  }

  listeCatalogosIfoodOficial(idLoja: string){
    return this.obtenha(String(`/importador/ifoodoficial/catalogos/${idLoja}`), {})
  }


  listeAdicionaisProdutosIfood(link: string, idsProdutosIfood: string[], reducao: number){
    const idLoja = this.obtenhaIdDaLoja(link)
    return this.obtenha(String(`/importador/ifood/produtos/${idLoja}/adicionais`), {
      idsProdutosIfood: idsProdutosIfood,
      reducao: reducao
    })
  }


  listeNovosProdutosAnotaAi(link: string, reducao: number, sincronizarPrecos: boolean = false,
                          sincronizarImagens: boolean = false, salvarDadosEmpresa: boolean = false){
    let params: any = {};

    if(reducao >= 0) params.reducao = reducao;
    if(sincronizarPrecos) params.precos = true;
    if(sincronizarImagens) params.imagens = true;
    if(salvarDadosEmpresa) params.salvarDadosEmpresa = true;

    const idLoja = this.obtenhaIdDaLoja(link)


    return this.obtenha(  String(`/importador/anotaai/produtos/${idLoja}/novos`), params)
  }

  listeNovosProdutosOlaclick(link: string, reducao: number, sincronizarPrecos: boolean = false,
                          sincronizarImagens: boolean = false, salvarDadosEmpresa: boolean = false){
    let params: any = {};

    params.url = link;
    if(reducao >= 0) params.reducao = reducao;
    if(sincronizarPrecos) params.precos = true;
    if(sincronizarImagens) params.imagens = true;
    if(salvarDadosEmpresa) params.salvarDadosEmpresa = true;

    return this.obtenha(String(`/importador/olaclick/produtos/novos`), params)
  }

  listeNovosProdutosCardapioWeb(link: string, reducao: number, sincronizarPrecos: boolean = false,
                             sincronizarImagens: boolean = false, salvarDadosEmpresa: boolean = false){
    let params: any = {};

    params.url = link;
    if(reducao >= 0) params.reducao = reducao;
    if(sincronizarPrecos) params.precos = true;
    if(sincronizarImagens) params.imagens = true;
    if(salvarDadosEmpresa) params.salvarDadosEmpresa = true;

    return this.obtenha(String(`/importador/cardapioweb/produtos/novos`), params)
  }

  listeNovosProdutosGoomer(link: string, reducao: number, sincronizarPrecos: boolean = false,
                           sincronizarImagens: boolean = false, salvarDadosEmpresa: boolean = false){
    let params: any = {};

    params.url = link;
    if(reducao >= 0) params.reducao = reducao;
    if(sincronizarPrecos) params.precos = true;
    if(sincronizarImagens) params.imagens = true;
    if(salvarDadosEmpresa) params.salvarDadosEmpresa = true;

    return this.obtenha(String(`/importador/goomer/produtos/novos`), params)
  }

  listeNovosProdutosUaiRango(link: string, reducao: number, sincronizarPrecos: boolean = false,
                             sincronizarImagens: boolean = false, salvarDadosEmpresa: boolean = false){
    let params: any = {};

    params.url = link;
    if(reducao >= 0) params.reducao = reducao;
    if(sincronizarPrecos) params.precos = true;
    if(sincronizarImagens) params.imagens = true;
    if(salvarDadosEmpresa) params.salvarDadosEmpresa = true;

    return this.obtenha(String(`/importador/uairango/produtos/novos`), params)
  }

  listeNovosProdutosAiqFome(link: string, reducao: number, sincronizarPrecos: boolean = false,
                            sincronizarImagens: boolean = false, salvarDadosEmpresa: boolean = false){
    let params: any = {};

    params.url = link;
    if(reducao >= 0) params.reducao = reducao;
    if(sincronizarPrecos) params.precos = true;
    if(sincronizarImagens) params.imagens = true;
    if(salvarDadosEmpresa) params.salvarDadosEmpresa = true;

    return this.obtenha(String(`/importador/aiqfome/produtos/novos`), params)
  }

  listeNovosProdutosInstaDelivery(link: string, reducao: number, sincronizarPrecos: boolean = false,
                                  sincronizarImagens: boolean = false, salvarDadosEmpresa: boolean = false){
    let params: any = {};

    params.url = link;
    if(reducao >= 0) params.reducao = reducao;
    if(sincronizarPrecos) params.precos = true;
    if(sincronizarImagens) params.imagens = true;
    if(salvarDadosEmpresa) params.salvarDadosEmpresa = true;

    return this.obtenha(String(`/importador/instadelivery/produtos/novos`), params)
  }

  listeNovosProdutosMenuDino(link: string, reducao: number, sincronizarPrecos: boolean = false,
                             sincronizarImagens: boolean = false, salvarDadosEmpresa: boolean = false){
    let params: any = {};

    params.url = link;
    if(reducao >= 0) params.reducao = reducao;
    if(sincronizarPrecos) params.precos = true;
    if(sincronizarImagens) params.imagens = true;
    if(salvarDadosEmpresa) params.salvarDadosEmpresa = true;

    return this.obtenha(String(`/importador/menudino/produtos/novos`), params)
  }

  obtenhaIdDaLoja(link: string){
    if(link.split('/').length > 0){
      let partes: any = link.split('?')[0].split('/');

      return  partes[partes.length - 1 ];
    }

    return link;

  }

  extraiaSlugLojaAnota(urlStr: string): string | null {
    //    ///https://pedido.anota.ai/loja/BrocaoFastFood?from=site&utm_source=ig&referer=https://l.instagram.com/
    if(urlStr.startsWith('http')){
      try {
        const url = new URL(urlStr);
        const match = url.pathname.match(/^\/loja\/([^\/?#]+)/i);
        return match ? decodeURIComponent(match[1]) : null;
      } catch {
        return null;
      }
    } else {
      return urlStr;
    }

  }


  importeProduto(produto: any){
    return this.facaPost('/importador/produto', produto)
  }

  importe(idEmpresa: number, link: number, reducao: number) {
    return this.salve('/importador/empresa/' + idEmpresa + '/ifood', {link: link, reducao: reducao})
  }

  finalizouImportacao(){
    return this.facaPost('/importador/finalizou', {})
  }

  salveLinkIfod(linkIfood: string){
    return this.facaPost('/importador/catalogo/salveLojaIfood', {linkIfood: linkIfood})
  }

}
